import request from '@/plugins/http'

export function productListApi(param) {
    return request.post('/api/admin/product/list', param);
}

export function productAddApi(param) {
    return request.post('/api/admin/product/add', param);
}

export function productDetailApi(param) {
    return request.post('/api/admin/product/detail', param);
}

export function productDeleteApi(param) {
    return request.post('/api/admin/product/delete', param);
}

export function languageTranslateApi(param) {
    return request.post('/api/admin/product/languageTranslate', param);
}




